// extracted by mini-css-extract-plugin
export default {"infoWrapper":"ElVBx","answerText":"D0_B_","answerCounts":"LZaeS","answerCount":"Mbbtq","answerPercentage":"QR39s","usersIcon":"xubrr"};